<template>
    <div class="site-main article-page">
    	<div class="article">
			<list :items="events" class="mb20 b-shadow"></list>
			<infinite-loading @infinite="onInfinite" ref="infiniteLoading" v-show="control == false">
	      		<span slot="no-more">我是有底线的</span>
	    	</infinite-loading>
	    	<div class="more-btn" @click="loadMore" v-show="control == true">
	    		<img src="../common/images/more-icon.png" alt="加载更多">
	    	</div>
    	</div>
    </div>
</template>

<script>
import list from '../components/List.vue';
import {httpHead,apiUrl,setSEO} from '../common/util/config.js';
import InfiniteLoading from 'vue-infinite-loading'
export default {
    data () {
        return {
        	events: [],
        	page: 0,
        	totalPage: 0,
        	control:false,
        	cid:5,
        	pageSeo: {}
        }
    },
    created () {
    	let postData = this.$qs.stringify({
			'cid': this.cid
		});
		let url = apiUrl+'api/lists'
		this.$axios({
			method: 'post',
		    url: url,
		    headers: httpHead,
		    data:postData
    	})
    		.then(res => {
                this.pageSeo = res.data.data.seo;
                setSEO(this.pageSeo);
            })
            .catch(err => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    },
    methods: {
    	onInfinite ($state) {
    		let postData = this.$qs.stringify({
			    cid: this.cid
			});
			this.page++;
			let url = apiUrl+'api/lists/page/'+this.page
    		this.$axios({
    			method: 'post',
			    url: url,
			    headers: httpHead,
			    data:postData
    		})
	        	.then(res => {
	        		this.totalPage = res.data.data.list.last_page;
	                this.events = this.events.concat(res.data.data.list.data);
	                if(this.page > 2){
	                	this.control = true;
	                }
	                if(this.control == false){
	                	$state.loaded();
	                }
	                
	                if(this.totalPage == this.page){
	                	$state.complete();
	                }
	            })
	            .catch(err => {
	                if (err.response) {
	                    console.log(err.response)
	                    $state.complete()
	                }
	            })
	    },
	    loadMore () {
	    	this.control = false;
	    	this.$nextTick(() => {
		        this.$refs.infiniteLoading.attemptLoad();
		    });
	    }
    },
    components: {
    	list,
    	InfiniteLoading
    }
}
</script>


// WEBPACK FOOTER //
// src/page/featuredView.vue